var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPeriodicChange = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 25.375C14.5743 25.375 16.0747 25.0587 17.4411 24.4861C17.6224 24.9712 17.9074 25.4058 18.269 25.7629C16.6585 26.4778 14.8756 26.875 13 26.875C5.8203 26.875 0 21.0547 0 13.875C0 6.6953 5.8203 0.875 13 0.875C20.1797 0.875 26 6.6953 26 13.875C26 16.6284 25.144 19.1818 23.6836 21.2838C23.3982 20.8587 23.0227 20.4991 22.5846 20.2321C23.7949 18.4111 24.5 16.2254 24.5 13.875C24.5 7.52373 19.3513 2.375 13 2.375C6.64873 2.375 1.5 7.52373 1.5 13.875C1.5 20.2263 6.64873 25.375 13 25.375ZM19.2404 25.282C18.8307 24.9772 18.5163 24.5513 18.3502 24.0573C18.265 23.8037 18.2188 23.5323 18.2188 23.25C18.2188 21.852 19.352 20.7188 20.75 20.7188C21.2015 20.7188 21.6254 20.837 21.9924 21.0441C22.4404 21.297 22.8037 21.6824 23.029 22.1471C23.1906 22.4805 23.2812 22.8547 23.2812 23.25C23.2812 24.648 22.148 25.7812 20.75 25.7812C20.1843 25.7812 19.6619 25.5957 19.2404 25.282ZM19.25 13.875C19.25 17.3268 16.4518 20.125 13 20.125C9.54822 20.125 6.75 17.3268 6.75 13.875C6.75 10.4232 9.54822 7.625 13 7.625C16.4518 7.625 19.25 10.4232 19.25 13.875Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPeriodicChange);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/periodic-change.d9328c1b43573a8b77efa51831d84fe8.svg";